// Вертикальный таймлайн варианта — сигнатурный элемент Trip Builder: линия слева,
// карточки сегментов на ней, узлы-маркеры, стыки между рейсами, индикатор вставки при dnd.
import { Fragment } from 'react';
import type { TripVariant, VariantTotals } from '../../types';
import { useStore } from '../../store';
import { useT } from '../../i18n';
import { useDnd } from '../dnd';
import { Connection } from './Connection';
import { TimelineCard } from './TimelineCard';
import styles from './Timeline.module.css';

export interface TimelineProps {
  variant: TripVariant;
  totals: VariantTotals;
}

function InsertLine({ active }: { active: boolean }) {
  return <div className={`${styles.insertLine} ${active ? styles.insertLineActive : ''}`} aria-hidden="true" />;
}

export function Timeline({ variant, totals }: TimelineProps) {
  const state = useStore();
  const dnd = useDnd();
  const t = useT();
  const segIds = variant.segmentIds;

  // В заблокированный вариант ничего не кладём — линию вставки тоже не показываем.
  const overHere =
    variant.locked !== true && dnd.over?.variantId === variant.id ? dnd.over.index : null;
  const showCopyLabel =
    !!dnd.drag &&
    !!dnd.drag.fromVariantId &&
    dnd.drag.fromVariantId !== variant.id &&
    overHere !== null;

  const connByTo = new Map(totals.connections.map((c) => [c.toSegmentId, c]));

  if (segIds.length === 0) {
    return (
      <div className={styles.timeline}>
        <InsertLine active={overHere === 0} />
        <div className={styles.empty}>
          <p className={styles.emptyTitle}>{t('timeline.empty.title')}</p>
          <p className={styles.emptyHint}>{t('timeline.empty.hint')}</p>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.timeline}>
      {showCopyLabel && <div className={styles.copyLabel}>{t('timeline.copyHere')}</div>}
      {segIds.map((id, i) => {
        const segment = state.library[id];
        if (!segment) return null;
        const connection = segment.kind === 'flight' ? connByTo.get(id) : undefined;
        return (
          <Fragment key={id}>
            <InsertLine active={overHere === i} />
            {connection && <Connection info={connection} />}
            <TimelineCard
              segment={segment}
              variantId={variant.id}
              index={i}
              totalCount={segIds.length}
              totals={totals}
              locked={variant.locked === true}
            />
          </Fragment>
        );
      })}
      <InsertLine active={overHere === segIds.length} />
    </div>
  );
}
